import templateStr from 'text!./templates/document-upload.html';

const ENTER_KEY = 13;

export default [
    'UploadTokenService', 'TranslateService', '$document', 'httpSettings', 'ModalService', 'maxFileUploadSize', 'EventHub', 'oAuth', 'FileUploadUtil',
    (UploadTokenService, TranslateService, $document, httpSettings, ModalService, maxFileUploadSize, EventHub, oAuth, FileUploadUtil) => {
        return {
            restrict: 'A',
            template: templateStr,
            transclude: true,
            scope: {
                metadataTemplate: '&metadata',
                documents: '=',
                toggleDisabled: '=',
                serviceName: '@',
                sessionServiceName: '@',
                claimState: '=',
                disableAutoUpload: '@disableAutoUpload',
                xCenter: '@gwPlDocumentUpload',
                dropZoneSelector: '&',
                customClass: '=',
                widgetIcon: '@',
                widgetText: '@',
                allowedFiles: '@',
                showErrorModal: '@'
            },
            link: (scope, element) => {
                scope.sessionToken = null;
                scope.serviceName = scope.serviceName || 'upload';
                scope.sessionServiceName = scope.sessionServiceName || 'docs/docsession';
                scope.buttonIcon = scope.widgetIcon || 'fa-plus';
                scope.buttonText = scope.widgetText || 'platform.documentupload.templates.document-upload.Upload Documents';
                scope.allowedFilesTypes = scope.allowedFiles || '.xls,.xlsx,.pdf,.txt,.doc,.docx,.png,.jpg';
                scope.showErrorModal = scope.showErrorModal ? scope.showErrorModal : 'true';
                scope.tooltipText = scope.buttonText;
                const dropZoneElement = FileUploadUtil.createDropZoneElement(scope.dropZoneSelector(), $document);
                scope.options = FileUploadUtil.createOptions(
                    httpSettings.serviceBaseURLs[scope.xCenter] + scope.serviceName,
                    !scope.disableAutoUpload,
                    maxFileUploadSize,
                    dropZoneElement
                );

                FileUploadUtil.addAuthTokenHeader(scope.options, oAuth)
                    .then((options) => {
                        options.dropZone = dropZoneElement;
                        scope.options = options;
                    });

                UploadTokenService.generateUploadToken(scope.xCenter, scope.sessionServiceName)
                    .then((response) => {
                        scope.sessionToken = response;
                    }).catch(() => {
                        scope.tooltipText = 'platform.documentupload.templates.document-upload.You seem to be offline. Once your connection is restored, click “Previous” and start the process again.';
                    });

                scope.metadata = [];
                let newDocuments = [];
                let errorUploading = false;
                let fileTypeMismatch = false;
                scope._unbind = function (eventname) {
                    if (eventname in scope._unbind.handlers) {
                        scope._unbind.handlers[eventname]();
                    }
                };
                scope._unbind.handlers = {};

                const bind = (eventname, cb) => {
                    scope._unbind.handlers[eventname] = scope.$on(eventname, cb);
                };

                function getFileTypeBySignature(file) {
                    return new Promise((resolve, reject) => {
                        const reader = new FileReader();
                        reader.onloadend = function () {
                            const arr = (new Uint8Array(reader.result)).subarray(0, 4);
                            let header = '';
                            for (let i = 0; i < arr.length; i++) {
                                header += arr[i].toString(16);
                            }
                            resolve(header);
                        };
                        reader.onerror = function () {
                            reject('Error reading the file');
                        };
                        reader.readAsArrayBuffer(file.slice(0, 4));
                    });
                }

                async function fileTypeChecker(data) {
                    const signature = await getFileTypeBySignature(data.files[0]);
                    const fileType = data.files[0].type;
                    console.log('Signature:', signature, 'mime type:', fileType);
                    if (fileType == "application/pdf" && signature.startsWith("25504446")) { //.pdf
                        fileTypeMismatch = false;
                    } else if (fileType == "text/plain" && !(signature.startsWith("25504446") || signature.startsWith("d0cf11e0") ||
                        signature.startsWith("504b34") || signature.startsWith("504b56") || signature.startsWith("504b78") ||
                        signature.startsWith("89504e47") || signature.startsWith("47494638") || signature.startsWith("ffd8ffe8") ||
                        signature.startsWith("ffd8ffe0") || signature.startsWith("ffd8ffe1") || signature.startsWith("ffd8ffe2") ||
                        signature.startsWith("ffd8ffe3"))) { //.txt
                        fileTypeMismatch = false;
                    } else if (fileType == "application/vnd.ms-excel" && signature.startsWith("d0cf11e0")) { //.xls
                        fileTypeMismatch = false;
                    } else if (fileType == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
                        (signature.startsWith("504b34") || signature.startsWith("504b56") || signature.startsWith("504b78"))) { //.xlsx
                        fileTypeMismatch = false;
                    } else if (fileType == "application/msword" && signature.startsWith("d0cf11e0")) { //.doc
                        fileTypeMismatch = false;
                    } else if (fileType == "application/vnd.openxmlformats-officedocument.wordprocessingml.document" &&
                        (signature.startsWith("504b34") || signature.startsWith("504b56") || signature.startsWith("504b78"))) { //.docx
                        fileTypeMismatch = false;
                    } else if (fileType == "image/png" && signature.startsWith("89504e47")) { //.png
                        fileTypeMismatch = false;
                    } else if (fileType == "image/gif" && signature.startsWith("47494638")) { //.gif
                        fileTypeMismatch = false;
                    } else if (fileType == "image/jpeg" && (signature.startsWith("ffd8ffdb") || signature.startsWith("ffd8ffee")
                        || signature.startsWith("ffd8ffe8") || signature.startsWith("ffd8ffe0") || signature.startsWith("ffd8ffe1")
                        || signature.startsWith("ffd8ffe2") || signature.startsWith("ffd8ffe3")) &&
                        (data.files[0].name.split(".").length == 2 && data.files[0].name.split(".")[1].toUpperCase() != 'JPEG')) { //.jpg
                        fileTypeMismatch = false;
                    } else if (fileType.startsWith("video")) { //INCI11828569  | unable to upload video
                        fileTypeMismatch = false;
                    } else {
                        console.log("File upload rejected at portal end");
                        fileTypeMismatch = true;
                        data.abort();
                    }
                }

                bind('fileuploadadd', (e, data) => {
                    data.files[0].metadata = FileUploadUtil.createDocMetadata(scope.metadataTemplate(), data, scope.sessionToken);
                    data.formData = {
                        document: JSON.stringify(data.files[0].metadata)
                    };
                    corruptedFileHandler(data);
                    scope.showErrorModal = 'true';
                });

                bind('fileuploaddone', (e, data) => {
                    const uploadResult = data.result.result;

                    newDocuments.push(uploadResult);
                    e.targetScope.clear(data.files);

                    EventHub.publish('journey', 'document', {
                        action: 'upload',
                        fileName: uploadResult.name,
                        documentType: uploadResult.documentType,
                        mimeType: uploadResult.mimeType
                    });
                });

                /**
                 * Add the temporarily held documents in newDocuments to the documents array.
                 * We reset the newDocuments array back to zero after we have added it to the documents array.
                 * We do this because old references to previously added documents may remain, and
                 * an exception will be thrown if you try to add the same document twice.
                 */
                bind('fileuploadstop', () => {
                    const result = FileUploadUtil.handleFileUploadStop(scope.documents, newDocuments, errorUploading, false);
                    scope.documents = result.documents;
                    newDocuments = result.newDocuments;
                    errorUploading = result.errorUploading;
                });

                bind('fileuploadfail', () => {
                    errorUploading = true;
                    if (scope.isFileInvalid == true) {
                        scope.isFileInvalid = false;
                        scope.showErrorModal = 'false';
                        ModalService.showError('platform.documentupload.DocumentUploadDirective.Error',
                            'platform.widgets.fileupload.templates.Missing required field Document Error');
                    } else if (fileTypeMismatch === true) {
                        fileTypeMismatch = false;
                        scope.showErrorModal = 'false';
                        ModalService.showError('platform.documentupload.DocumentUploadDirective.Error',
                            'platform.documentupload.DocumentUploadDirective.File could not be uploaded because the file name extension is not allowed.');
                    } else if (scope.showErrorModal === 'true') {
                        ModalService.showError('platform.documentupload.DocumentUploadDirective.Error',
                            'platform.documentupload.DocumentUploadDirective.Failed to upload file, either you do not have permission or a file exists with the same name.');
                    }
                });

                bind('fileuploadprocessfail', (e, data) => {
                    errorUploading = true;
                    if (fileTypeMismatch === true) {
                        fileTypeMismatch = false;
                        scope.showErrorModal = 'false';
                        ModalService.showError('platform.documentupload.DocumentUploadDirective.Error',
                            'platform.documentupload.DocumentUploadDirective.File could not be uploaded because the file name extension is not allowed.');
                    } else if (scope.showErrorModal === 'true') {
                        ModalService.showError('platform.documentupload.DocumentUploadDirective.Processing file failed.',
                            {
                                fileName: data.originalFiles[0].name,
                                error: TranslateService.instant(`platform.documentupload.DocumentUploadDirective.Error.${data.originalFiles[0].error}`)
                            }
                        );
                    }
                });
                // A11Y enter key to fire input type=file click
                const input = element.find('input');
                const fileUpload = element.find('#uploadButton');
                fileUpload.on('keydown', (evt) => {
                    if (evt.keyCode === ENTER_KEY) {
                        evt.stopPropagation();
                        evt.preventDefault();
                        input.click();
                    }
                });
                fileUpload.on('click', (evt) => {
                    errorUploading = false; //UCWAR-2298 defect fix
                    if(scope.claimState === 'closed'){
                        evt.stopPropagation();
                        evt.preventDefault();
                    } else if (scope.metadataTemplate().documentType === 'letter_received') {
                        evt.stopPropagation();
                        evt.preventDefault();
                        const title = 'platform.widgets.fileupload.templates.Missing required field Document Type';
                        ModalService.showError(title);
                    }
                });

                function corruptedFileHandler(data) {
                    scope.isFileInvalid = false;
                    const files = data.files;
                    for (let i = 0; i < files.length; i++) {
                        const file = files[i];
                        try {
                            if (file.size === 0) {
                                scope.isFileInvalid = true;
                                data.abort();
                                return false;
                            }
                            if (file.type === 'application/pdf') {
                                readPDF(file, data).then(pdfData => {
                                    console.log("PDF data: " + pdfData);
                                }).catch(error => {
                                    scope.isFileInvalid = true;
                                    data.abort();
                                    reject(new Error('Corrupt or invalid file'));
                                    return false;
                                });
                            } else if (file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                                || file.type == 'application/msword') {
                                readDOCX(file, data).then(docxData => {
                                    console.log("docxData: " + docxData);
                                }).catch(error => {
                                    scope.isFileInvalid = true;
                                    data.abort();
                                    throw (new Error('Corrupt or invalid file'));
                                    return false;
                                });
                            } else if (file.type.startsWith('image/')) {
                                readImage(file, data).then(imageData => {
                                    console.log("Image file data:  " + imageData);
                                }).catch(error => {
                                    scope.isFileInvalid = true;
                                    data.abort();
                                    throw new Error('Corrupt or invalid file');
                                    return false;
                                });
                            } else if (file.type === 'text/plain') {
                                readText(file, data).then(textData => {
                                    console.log("text/plain file data: " + textData);
                                }).catch(error => {
                                    scope.isFileInvalid = true;
                                    data.abort();
                                    throw new Error('Corrupt or invalid file');
                                    return false;
                                });
                            } else {
                                fileTypeChecker(data);
                            }
                        } catch (error) {
                            console.error('Error processing corrupted file');
                            scope.isFileInvalid = true;
                            data.abort();
                            return false;
                        }
                    }
                }

                //Validate files
                function readPDF(file, data) {
                    const fileInfo = 'platform.widgets.fileupload.templates.Missing required field Document Error';
                    return new Promise((resolve, reject) => {
                        const reader = new FileReader();
                        reader.onload = function (event) {
                            const typedarray = new Uint8Array(event.target.result);
                            // pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.11.338/pdf.min.js';

                            const loadingTask = new pdfjsLib.getDocument({ data: typedarray });
                            //const mypdftask =require('./pdf.min.js');
                            loadingTask.promise.then(function (pdfDocument) {
                                const numPages = pdfDocument.numPages;
                                if (numPages === 0) {
                                    reject(new Error('platform.widgets.fileupload.templates.Missing required field Document Error'));
                                    return;
                                }
                                // For simplicity, let's just extract text from the first page
                                pdfDocument.getPage(1).then(function (page) {
                                    page.getTextContent().then(function (textContent) {
                                        const textItems = textContent.items.map(item => item.str).join(' ');
                                        resolve(textItems);
                                        fileTypeChecker(data);
                                    }).catch(error => {
                                        reject(new Error('platform.widgets.fileupload.templates.Missing required field Document Error'));
                                        return;
                                    });
                                }).catch(error => {
                                    reject(new Error('platform.widgets.fileupload.templates.Missing required field Document Error'));
                                    return;
                                });
                            }).catch(error => {
                                reject(new Error('platform.widgets.fileupload.templates.Missing required field Document Error'));
                                return;
                            });
                        };
                        reader.onerror = function (error) {
                            reject(new Error('platform.widgets.fileupload.templates.Missing required field Document Error'));
                            console.error('Error processing ${file.name}:', fileInfo);
                        };
                        reader.readAsArrayBuffer(file);
                    });
                }

                function readDOCX(file, data) {
                    return new Promise((resolve, reject) => {
                        //pdfjsLib.GlobalWorkerOptions.workerSrc ='https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.11.338/pdf.min.js';
                        mammoth.extractRawText({ arrayBuffer: file })
                            .then(result => {
                                const text = result.value.trim(); // Trim whitespace
                                if (text === '') {
                                    reject(new Error('platform.widgets.fileupload.templates.Missing required field Document Error'));
                                    return;
                                }
                                resolve(text);
                                fileTypeChecker(data);
                            }).catch(reject);
                    });
                }

                function readImage(file, data) {
                    return new Promise((resolve, reject) => {
                        const img = new Image();
                        img.onload = function () {
                            if (img.width === 0 || img.height === 0) {
                                reject(new Error('platform.widgets.fileupload.templates.Missing required field Document Error'));
                                return;
                            }
                            resolve({ width: img.width, height: img.height });
                            fileTypeChecker(data);
                        };
                        img.onerror = function () {
                            reject(new Error('platform.widgets.fileupload.templates.Missing required field Document Error'));
                        };
                        img.src = URL.createObjectURL(file);
                    });
                }

                function readText(file, data) {
                    return new Promise((resolve, reject) => {
                        const reader = new FileReader();
                        reader.onload = function (event) {
                            const text = event.target.result.trim(); // Trim whitespace
                            if (text === '') {
                                reject(new Error('platform.widgets.fileupload.templates.Missing required field Document Error'));
                                return;
                            }
                            resolve(text);
                            fileTypeChecker(data);
                        };
                        reader.onerror = function () {
                            reject(new Error('platform.widgets.fileupload.templates.Missing required field Document Error'));
                        };
                        reader.readAsText(file);
                    });
                }
            }
        };

    }];